import { HeaderCtaProps } from 'libs/contentful/props';
import CTA from 'components/shared/CTA/CTA';
import Link from 'components/shared/Link/Link';
import { RemoteImage } from '@1debit/chimekit';
import { cn, getColorway } from 'utils/styles';
import { getColorwayName } from 'utils/formatters';
import { Colorways } from 'types/constants';

const HeaderCta = ({ cta, color }: HeaderCtaProps) => {
  const logoToken =
    getColorwayName(color) === Colorways.Inverse
      ? 'ck.logo.chime.primary_neutral.small.registered'
      : 'ck.logo.chime.chime_green.small.registered';

  return (
    <div
      className={cn('px-6 sm:px-14 py-4 flex justify-between h-18', getColorway(color))}
      data-testid="header-cta"
      data-theme={'dark'}>
      <Link href="/">
        <RemoteImage token={logoToken} alt="Chime Home" />
      </Link>

      <div className="sm:min-w-[200px] h-full flex">
        <CTA cta={cta} />
      </div>
    </div>
  );
};

export default HeaderCta;
